import { render, staticRenderFns } from "./NewBroadcastMessageComponent.vue?vue&type=template&id=39f348a7"
import script from "./NewBroadcastMessageComponent.vue?vue&type=script&lang=js"
export * from "./NewBroadcastMessageComponent.vue?vue&type=script&lang=js"
import style0 from "./NewBroadcastMessageComponent.vue?vue&type=style&index=0&id=39f348a7&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports